import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const PeerReviewIcon = (props) => {
  const {getThemeColorForTab } =
    useContext(themeContext);
  return (
    <svg
      fill="#000000"
      width="15"
      height="18"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1507.339 693h-120.64V572.36l225.386-225.493 120.747 120.64L1507.339 693ZM604.8 479.667c56.448 0 85.236 25.61 113.597 51.733l3.473 3.2c28.371 26.123 57.426 51.733 114.397 51.733 54.566 0 83.297-24.14 110.706-49.381l1.889-1.742 1.886-1.744 1.885-1.745 1.887-1.742a887.573 887.573 0 0 1 4.733-4.339c.107 2.56.747 4.907.747 7.36v106.667c0 146.986-119.68 266.666-266.667 266.666-146.986 0-266.666-119.68-266.666-266.666v-64c24.074-9.749 41.782-25.426 59.326-41.31l2.844-2.576c28.925-26.196 58.314-52.114 115.963-52.114ZM1624.885 183.24c28.48-28.373 74.774-28.48 103.147 0l168.32 168.32c28.48 28.48 28.48 74.773 0 103.253l-323.52 323.52c-14.08 13.867-32.213 21.334-51.52 21.334h-241.28v-241.28c0-19.307 7.467-37.547 21.013-51.307ZM1108.053 949c-57.066-11.947-114.666-20.693-172.48-27.627 79.574-68.586 131.094-168.746 131.094-281.706V533c0-205.867-167.467-373.333-373.334-373.333C487.467 159.667 320 327.133 320 533v106.667c0 112.746 51.2 212.693 130.56 281.173-57.6 7.04-114.987 16.213-171.733 28.053C117.333 982.92 0 1136.84 0 1314.973v204.907l21.653 16c128.64 94.933 340.587 210.667 619.947 223.787 17.173.746 34.133 1.173 50.987 1.173 317.013 0 555.413-138.987 672.32-224.853l21.76-16V1315.08c0-178.133-117.227-332.053-278.614-366.08"
        fill-rule="evenodd"
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default PeerReviewIcon;
